function calculateMilliseconds(days: number, hours: number, minutes: number, seconds: number): number {
    return (
        (days * 24 * 60 * 60 * 1000) +
        (hours * 60 * 60 * 1000) +
        (minutes * 60 * 1000) +
        (seconds * 1000)
    );
}

let countdownIntervalId: number | null = null;

export function startCountdown(
    days: number,
    hours: number,
    minutes: number,
    seconds: number,
    onUpdate: (remainingTime: { days: number; hours: number; minutes: number; seconds: number }) => void,
    onComplete: () => void
): number {
    // ✅ Ferma il countdown precedente se esiste
    if (countdownIntervalId !== null) {
        clearInterval(countdownIntervalId);
    }

    let totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;

    countdownIntervalId = window.setInterval(() => {
        totalSeconds--;

        if (totalSeconds <= 0) {
            stopCountdown();
            onComplete();
            return;
        }

        const d = Math.floor(totalSeconds / 86400);
        const h = Math.floor((totalSeconds % 86400) / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        onUpdate({ days: d, hours: h, minutes: m, seconds: s });
    }, 1000);

    return countdownIntervalId; // ✅ Restituisci l'ID
}

export function stopCountdown(): void {
    if (countdownIntervalId !== null) {
        clearInterval(countdownIntervalId);
        countdownIntervalId = null;
    }
}